import { useEffect, useState } from "react";
import { timeLeft } from "../lib/format";

export function Countdown({ to }: { to: number }) {
  const [now, setNow] = useState(() => Date.now() / 1000);
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now() / 1000), 1000);
    return () => clearInterval(t);
  }, []);
  return <span className="num">{timeLeft(to, now)}</span>;
}

/** Next 00:00 or 12:00 UTC: when holder rewards are posted. */
export function nextPayoutTs(now = Date.now() / 1000): number {
  const half = 12 * 3600;
  return (Math.floor(now / half) + 1) * half;
}
